export default ({ request }) => ({
  detailDesignElementsTagApi(data) {
    return request({
      url: '/digitalCenter/designElementsTag/detail',
      method: 'post',
      data
    })
  },
  listDesignElementsTagApi(data) {
    return request({
      url: '/digitalCenter/designElementsTag/list',
      method: 'post',
      data
    })
  },
  saveDesignElementsTagApi(data) {
    return request({
      url: '/digitalCenter/designElementsTag/save',
      method: 'post',
      data
    })
  },
  delDesignElementsTagApi(data) {
    return request({
      url: '/digitalCenter/designElementsTag/del',
      method: 'post',
      data
    })
  }
})
